export default "__VITE_ASSET__DbRetukG__"